//* Mêmes clés que le registre de suppression de l'API (app/Services/Deletion)
export type ResourceKey =
  | "courses"
  | "companies"
  | "company-courses"
  | "people"
  | "instructors"
  | "opcos"
  | "organisations"
  | "activity-sectors"
  | "email-templates"
  | "training-brochures"
  | "teams"
  | "team-users"
  | "users"
  | "softphone-lines"
  | "company-statuses"
  | "company-course-statuses"
  | "montage-meeting-statuses";

export interface IResourceConfig {
  singular: string;
  plural: string;
  feminine: boolean;
  //* Ce que fait « supprimer » à l'unité : effacer, ou archiver
  effect: "delete" | "archive";
  //* Types de tags RTK Query à invalider quand un job sur cette ressource se termine
  tags: string[];
  //* Avertissement supplémentaire dans la confirmation
  warning?: string;
}

export const RESOURCES: Record<ResourceKey, IResourceConfig> = {
  courses: {
    singular: "formation",
    plural: "formations",
    feminine: true,
    effect: "delete",
    tags: ["Courses"],
  },
  companies: {
    singular: "entreprise",
    plural: "entreprises",
    feminine: true,
    effect: "archive",
    tags: ["Companies"],
  },
  "company-courses": {
    singular: "dossier",
    plural: "dossiers",
    feminine: false,
    effect: "archive",
    tags: ["CompanyCourses"],
  },
  people: {
    singular: "personne",
    plural: "personnes",
    feminine: true,
    effect: "delete",
    tags: ["People"],
  },
  instructors: {
    singular: "formateur",
    plural: "formateurs",
    feminine: false,
    effect: "delete",
    tags: ["Instructors"],
  },
  opcos: {
    singular: "OPCO",
    plural: "OPCO",
    feminine: false,
    effect: "delete",
    tags: ["Opcos"],
  },
  organisations: {
    singular: "organisme",
    plural: "organismes",
    feminine: false,
    effect: "delete",
    tags: ["Organisations"],
  },
  "activity-sectors": {
    singular: "secteur d'activité",
    plural: "secteurs d'activité",
    feminine: false,
    effect: "delete",
    tags: ["ActivitySectors"],
  },
  "email-templates": {
    singular: "template d'email",
    plural: "templates d'emails",
    feminine: false,
    effect: "delete",
    tags: ["EmailTemplates"],
  },
  "training-brochures": {
    singular: "plaquette",
    plural: "plaquettes",
    feminine: true,
    effect: "delete",
    tags: ["TrainingBrochures"],
  },
  teams: {
    singular: "équipe",
    plural: "équipes",
    feminine: true,
    effect: "delete",
    tags: ["Teams"],
  },
  "team-users": {
    singular: "membre",
    plural: "membres",
    feminine: false,
    effect: "delete",
    tags: ["TeamUsers"],
  },
  users: {
    singular: "utilisateur",
    plural: "utilisateurs",
    feminine: false,
    effect: "delete",
    tags: ["Users"],
    warning:
      "Les comptes sont réellement supprimés, et leurs rendez-vous perdent leur auteur.",
  },
  "softphone-lines": {
    singular: "ligne softphone",
    plural: "lignes softphone",
    feminine: true,
    effect: "delete",
    tags: ["SoftphoneLines"],
  },
  "company-statuses": {
    singular: "statut d'entreprise",
    plural: "statuts d'entreprise",
    feminine: false,
    effect: "delete",
    tags: ["CompanyStatuses"],
  },
  "company-course-statuses": {
    singular: "statut de formation",
    plural: "statuts de formation",
    feminine: false,
    effect: "delete",
    tags: ["CompanyCourseStatuses"],
  },
  "montage-meeting-statuses": {
    singular: "statut de RDV montage",
    plural: "statuts de RDV montage",
    feminine: false,
    effect: "delete",
    tags: ["MontageMeetingStatuses", "MontageMeetings"],
  },
};
